export const CameraSharedColors = {
  Coral: '#FF7852',
  Magenta: '#FF08D6',
  Turquoise: '#2CE2DA',
  Lemon: '#F9FF00',
} as const;
